import React from "react"
import { useLabels } from "../../../../../features/contents/hooks"
import Typography from "../../../../../ui/atoms/Typography"
import { useAlgoliaSearchState } from "../../controller/state"

export const ResultsStats = () => {
  const { searchResults } = useAlgoliaSearchState()
  const { getLabel } = useLabels()
  return (
    <>
      {searchResults?.nbHits > 0 && (
        <Typography variant="body1">
          {searchResults.nbHits}{" "}
          {searchResults.nbHits === 1
            ? getLabel("search", "article")
            : getLabel("search", "articles")}
        </Typography>
      )}
    </>
  )
}
